import React, { useEffect, useState } from 'react';
import { VscGame } from 'react-icons/vsc';
import { FiArrowRight } from 'react-icons/fi';
import checkIcon from './img/check-icon.svg';
import xIcon from './img/x-icon.svg';
import { useClient } from 'jsonapi-react';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
import {
  ChallengeQuestion,
  ChallengeQuestionAlternative,
  ChallengeQuestionBody,
  ChallengeQuestionComment,
  ChallengeQuestionCommentContent,
  ChallengeQuestionCount,
  ChallengeQuestionFooter,
  ChallengeQuestionHeader,
  ChallengeQuestionIcon,
  ChallengeQuestionList,
  ChallengeQuestionRadio,
  ChallengeQuestionTitle
} from '@/components/custom/challenge';
import { Button, ButtonIcon } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';

export function WeekChallengeQuestion(props) {
  const { setCurrentIndexQuestion, currentIndexQuestion } = props;
  const client = useClient();
  const { currentChallenge, loading, setChallengeCurrentStatus, taxonomies, setStart, counter, currentAttempt, currentRound, setCurrentRound, setCurrentStep, setRightAnswers, questions } = useWeeklyChallenge();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentAnswer, setCurrentAnswer] = useState(null);
  const [submittedAnswer, setSubmittedAnswer] = useState(false);

  const startQuestion = async () => {
    await client.mutate(`/challenges/${currentChallenge?.id}/challenge_attempt_items/${currentAttempt}`, {
      'challenge-attempt-item-answers-attributes': [{ 'challenge-question-id': questions?.[currentIndexQuestion]?.id }]
    });
  };

  const handleAnswerQuestion = async (alternativeId, status) => {
    setStart(false);
    setSubmittedAnswer(true);
    setIsSubmitting(true);

    const payload = {
      'challenge-attempt-item-answers-attributes': [{ 'challenge-alternative-id': alternativeId, 'challenge-question-id': questions[currentIndexQuestion]?.id }]
    };

    if (status) {
      payload['challenge-attempt-item-answers-attributes'][0].status = status;
    }

    await client
      .mutate(`/challenges/${currentChallenge?.id}/challenge_attempt_items/${currentAttempt}`, payload)
      .then(response => {
        const currentAnswer = response.data['challenge-attempt-item-answers'].find(item => item['challenge-question'].id === questions[currentIndexQuestion]?.id);
        setChallengeCurrentStatus(response.data);
        setCurrentAnswer(currentAnswer);
        if (currentAnswer['is-correct']) {
          setRightAnswers(prev => prev + 1);
        }
      })
      .catch(err => {
        toast.error('Erro ao responder questão');
        console.log(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const skippQuestion = async () => {
    await client.mutate(`/challenges/${currentChallenge?.id}/challenge_attempt_items/${currentAttempt}`, {
      'challenge-attempt-item-answers-attributes': [{ 'challenge-question-id': questions[currentIndexQuestion]?.id, status: 'skipped' }]
    });
    setCurrentIndexQuestion(prev => prev + 1);
  };

  useEffect(() => {
    if (counter === 0) {
      handleAnswerQuestion(null, 'skipped');
    }
  }, [counter]);

  useEffect(() => {
    startQuestion();
  }, [currentIndexQuestion]);

  const handleNextQuestion = () => {
    if (currentAnswer) {
      if (currentIndexQuestion + 1 < questions?.length) {
        setCurrentIndexQuestion(currentIndexQuestion + 1);
        setSubmittedAnswer(false);
        setStart(true);
      } else if (currentIndexQuestion + 1 === questions?.length && taxonomies.length > 1) {
        setCurrentStep(1);
        setCurrentRound(currentRound + 1);
        setSubmittedAnswer(false);
        setStart(true);
      } else if (currentIndexQuestion + 1 === questions?.length && taxonomies.length === 1) {
        setCurrentStep(3);
        setCurrentRound(currentRound + 1);
        setSubmittedAnswer(false);
        setStart(true);
      }
    }
  };

  const getVariant = (item, currentAnswer) => {
    if (!currentAnswer) return null;

    if (currentAnswer['challenge-alternative-id'] === item.id) {
      return currentAnswer['is-correct'] ? 'success' : 'danger';
    }

    return null;
  };

  if (loading) return <Loader />;

  return (
    <ChallengeQuestion>
      <ChallengeQuestionCount>
        <VscGame /> {currentIndexQuestion + 1}
      </ChallengeQuestionCount>

      <ChallengeQuestionHeader>
        <ChallengeQuestionTitle>{questions?.[currentIndexQuestion]?.description}</ChallengeQuestionTitle>
      </ChallengeQuestionHeader>

      <ChallengeQuestionBody>
        <ChallengeQuestionList>
          {questions?.[currentIndexQuestion]?.['challenge-alternatives']?.map(item => {
            return (
              <ChallengeQuestionAlternative
                variant={getVariant(item, currentAnswer)}
                key={item?.id}
                disabled={isSubmitting}
                onClick={() => handleAnswerQuestion(item?.id)}
              >
                <ChallengeQuestionRadio /> {item?.description}
                {currentAnswer && currentAnswer['correct-alternative-id'] === item.id ? (
                  <ChallengeQuestionIcon
                    src={checkIcon}
                    alt="ícone de marcado"
                  />
                ) : null}
                {currentAnswer && currentAnswer['challenge-alternative-id'] === item.id && currentAnswer['is-correct'] ? (
                  <ChallengeQuestionIcon
                    src={checkIcon}
                    alt="ícone de marcado"
                  />
                ) : null}
                {currentAnswer && currentAnswer['challenge-alternative-id'] === item.id && !currentAnswer['is-correct'] ? (
                  <ChallengeQuestionIcon
                    src={xIcon}
                    alt="ícone de errado"
                  />
                ) : null}
              </ChallengeQuestionAlternative>
            );
          })}
        </ChallengeQuestionList>
      </ChallengeQuestionBody>

      <ChallengeQuestionFooter>
        {!submittedAnswer && questions?.length !== currentIndexQuestion + 1 && (
          <Button
            variant="outline"
            wide
            onClick={() => {
              skippQuestion();
            }}
          >
            <ButtonIcon>
              <FiArrowRight />
            </ButtonIcon>{' '}
            Pular
          </Button>
        )}

        {currentAnswer && submittedAnswer ? (
          <>
            <ChallengeQuestionComment>
              <AvatarWrapper
                size="md"
                src={currentAnswer['challenge-question']?.avatar?.url}
                text="foto do professor"
              />

              <ChallengeQuestionCommentContent>
                <p>
                  <strong>Comentários do seu professor:</strong> {currentAnswer?.['challenge-question']?.comment}
                </p>
              </ChallengeQuestionCommentContent>
            </ChallengeQuestionComment>

            <Button
              wide
              className="mt-5"
              onClick={handleNextQuestion}
            >
              Próxima questão
            </Button>
          </>
        ) : null}
      </ChallengeQuestionFooter>
    </ChallengeQuestion>
  );
}
